// @flow

import Router from 'next/router';
import queryString from 'query-string';

import { addTruthyParamsToUrl } from '@zapier/url-utils';

export const trackAndNavigate = (
  trackEvent: () => Promise<void>,
  options?: {
    forwardReferrer?: boolean,
  } = {}
) => async (evt: SyntheticEvent<HTMLAnchorElement>) => {
  evt.preventDefault();

  // In some cases, a referrer querystring param in the current URL should be
  // forwarded as a querystring param to the URL that we are
  // linking/navigating to. This is done, for example, for all links to the
  // /sign-up/ page. Unfortunately we cannot add the logic to merge the
  // referrer param into the href in a URL builder function, because it will
  // not always execute on the client side, because Next.js does not
  // re-render every portion of the page when the client boots. We also cannot
  // add the logic to the server-side rendering flow, because it will become
  // baked into the responses stored in the server-side response cache. So as
  // a last resort, the logic is being added here, in the onClick, where it
  // will consistently run on the client side before browser navigation is
  // triggered.
  const href = addTruthyParamsToUrl(evt.currentTarget.getAttribute('href'), {
    referrer:
      options.forwardReferrer &&
      queryString.parse(window.location.search).referrer,
  });

  try {
    await trackEvent();
  } catch (error) {
    console.error(
      JSON.stringify({
        message: 'Failed to track event',
        error: error.stack || error,
      })
    );
  } finally {
    Router.push(href);
  }
};
